// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from 'styled-components'; // Import ThemeProvider
import { Toaster } from 'sonner';
import App from './App';
import { GlobalStyle } from './styles/GlobalStyle';
import { theme } from './styles/theme'; // Import the theme object

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* Wrap the entire App with ThemeProvider and pass the theme */}
      <ThemeProvider theme={theme}>
        {/* GlobalStyle should be inside ThemeProvider to access the theme */}
        <GlobalStyle />
        <Toaster position="top-right" richColors />
        <App />
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
